import { CompactTable } from '@table-library/react-table-library/compact';
import { useTheme } from "@table-library/react-table-library/theme";
import { getTheme } from "@table-library/react-table-library/baseline";
import { useSort } from "@table-library/react-table-library/sort";
import { usePagination } from "@table-library/react-table-library/pagination";

const nodes = [
    {
        id: '0',
        name: 'Shopping List',
        type: 'TASK',
    },
    {
        id: '1',
        name: 'Pay Bills',
        type: 'TASK',
    },
    {
        id: '2',
        name: 'Workout Plan',
        type: 'HABIT',
    },
    {
        id: '3',
        name: 'Read a Book',
        type: 'GOAL',
    },
    {
        id: '4',
        name: 'Prepare Presentation',
        type: 'TASK',
    },
    {
        id: '5',
        name: 'Weekly Groceries',
        type: 'TASK',
    },
    {
        id: '6',
        name: 'Morning Run',
        type: 'HABIT',
    },
    {
        id: '7',
        name: 'Learn React',
        type: 'GOAL',
    },
    {
        id: '8',
        name: 'Clean Apartment',
        type: 'TASK',
    },
    {
        id: '9',
        name: 'Meditation',
        type: 'HABIT',
    },
];

const COLUMNS = [
    { label: 'Task', renderCell: (item) => item.name, sort: { sortKey: "TASK" } },
    { label: 'Type', renderCell: (item) => item.type },
];

function Zaposleni() {
    const data = { nodes }

    const theme = useTheme(getTheme());

    const sort = useSort(
        data,
        {
        },
        {
            sortFns: {
                TASK: (array) => array.sort((a, b) => a.name.localeCompare(b.name)),
                // DEADLINE: (array) => array.sort((a, b) => a.deadline - b.deadline),
                // TYPE: (array) => array.sort((a, b) => a.type.localeCompare(b.type)),
                // COMPLETE: (array) => array.sort((a, b) => a.isComplete - b.isComplete),
                // TASKS: (array) =>
                // array.sort((a, b) => (a.nodes || []).length - (b.nodes || []).length),
            },
        }
    );

    const pagination = usePagination(data, {
        state: {
            page: 0,
            size: 2,
        }
    });

    return (
        <div style={{ padding: "25px" }}>
            <CompactTable columns={COLUMNS} data={data} theme={theme} sort={sort} pagination={pagination} />

            <br />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>Total Pages: {pagination.state.getTotalPages(data.nodes)}</span>

                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    Page{" "}
                    {/* <div style={{ display: "flex" }}>
                        {pagination.state.getPages(data.nodes).map((_, index) => (
                            <button
                                key={index}
                                type="button"
                                style={{
                                    fontWeight: pagination.state.page === index ? "bold" : "normal",
                                    width: "30px",
                                    height: "30px"
                                }}
                                onClick={() => pagination.fns.onSetPage(index)}
                            >
                                {index + 1}
                            </button>
                        ))}
                    </div> */}

                    <button
                        type="button"
                        disabled={pagination.state.page === 0}
                        onClick={() => pagination.fns.onSetPage(0)}
                    >
                        {"<<"}
                    </button>
                    <button
                        type="button"
                        disabled={pagination.state.page === 0}
                        onClick={() =>
                            pagination.fns.onSetPage(pagination.state.page - 1)
                        }
                    >
                        {"<"}
                    </button>
                    <span>{pagination.state.page + 1}</span>
                    <button
                        type="button"
                        disabled={pagination.state.page + 1 === pagination.state.getTotalPages(data.nodes)}
                        onClick={() =>
                            pagination.fns.onSetPage(pagination.state.page + 1)
                        }
                    >
                        {">"}
                    </button>
                    <button
                        type="button"
                        disabled={pagination.state.page + 1 === pagination.state.getTotalPages(data.nodes)}
                        onClick={() =>
                            pagination.fns.onSetPage(pagination.state.getTotalPages(data.nodes) - 1)
                        }
                    >
                        {">|"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Zaposleni;
